require('./style.scss')
angular = require('angular')
class SelectorService
  @$inject: ["$uibModal"]
  constructor: (@modal)->

  select: (options)->
    {model, multi} = options
    template = if multi then require("./multi.pug") else require("./index.pug")
    if model is "Resource"
      template = require("./resource.pug")
    if model is "Device"
      template = require("./device.pug")
    instance = @modal.open
      template: template
      controller: SelectorServiceCtrl             
      controllerAs: '$ctrl'
      windowClass: 'modal-selector'
      resolve: 
        options: ()->
          return options?={}

    return instance.result

class SelectorServiceCtrl
  constructor: ($uibModalInstance, options)->
    @instance = $uibModalInstance  
    if options.model is "Device"
      {@title="Add Device", @model, @fields, @method="paginate", @filter, @selected, @multi, @nullable=false} = options   
    else
      {@title="Select Resource", @model, @fields, @method="paginate", @filter, @selected, @multi, @nullable=false} = options  
  confirm: ()->    
    @instance.close(@selected)
  cancel: ()->
    @instance.dismiss "cancelled"

module.exports = SelectorService


// WEBPACK FOOTER //
// ./src/common/selector/modal/index.coffee